/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedMeasurementUnitProvider_itemSearch$ref = any;
type SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch$ref = any;
type SbSharedRefineMenuInputRange_itemSearch$ref = any;
export type SbSharedRefineMenuInputRangeDimensions_itemSearch$ref = any;
export type SbSharedRefineMenuInputRangeDimensions_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuInputRange_itemSearch$ref & SbSharedMeasurementUnitProvider_itemSearch$ref & SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuInputRangeDimensions_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuInputRangeDimensions_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuInputRange_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedMeasurementUnitProvider_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'cb6e3bd8ddf0427262832fccadec368b';
export default node;
